// Fetch

export const FETCH = 'transportScoring.FETCH'
export const FETCH_STARTED = 'transportScoring.FETCH_STARTED'
export const FETCH_FULFILLED = 'transportScoring.FETCH_FULFILLED'
export const FETCH_REJECTED = 'transportScoring.FETCH_REJECTED'
export const FETCH_CANCELLED = 'transportScoring.FETCH_CANCELLED'

// Save question

export const SAVE_QUESTION = 'transportScoring.SAVE_QUESTION'
export const SAVE_QUESTION_STARTED = 'transportScoring.SAVE_QUESTION_STARTED'
export const SAVE_QUESTION_FULFILLED = 'transportScoring.SAVE_QUESTION_FULFILLED'
export const SAVE_QUESTION_REJECTED = 'transportScoring.SAVE_QUESTION_REJECTED'
export const SAVE_QUESTION_CANCELLED = 'transportScoring.SAVE_QUESTION_CANCELLED'

// Delete question

export const DELETE_QUESTION = 'transportScoring.DELETE_QUESTION'
export const DELETE_QUESTION_STARTED = 'transportScoring.DELETE_QUESTION_STARTED'
export const DELETE_QUESTION_FULFILLED = 'transportScoring.DELETE_QUESTION_FULFILLED'
export const DELETE_QUESTION_REJECTED = 'transportScoring.DELETE_QUESTION_REJECTED'
export const DELETE_QUESTION_CANCELLED = 'transportScoring.DELETE_QUESTION_CANCELLED'

// Move question UP

export const MOVE_QUESTION_UP = 'transportScoring.MOVE_QUESTION_UP'
export const MOVE_QUESTION_UP_STARTED = 'transportScoring.MOVE_QUESTION_UP_STARTED'
export const MOVE_QUESTION_UP_FULFILLED = 'transportScoring.MOVE_QUESTION_UP_FULFILLED'
export const MOVE_QUESTION_UP_REJECTED = 'transportScoring.MOVE_QUESTION_UP_REJECTED'
export const MOVE_QUESTION_UP_CANCELLED = 'transportScoring.MOVE_QUESTION_UP_CANCELLED'

// Move question DOWN

export const MOVE_QUESTION_DOWN = 'transportScoring.MOVE_QUESTION_DOWN'
export const MOVE_QUESTION_DOWN_STARTED = 'transportScoring.MOVE_QUESTION_DOWN_STARTED'
export const MOVE_QUESTION_DOWN_FULFILLED = 'transportScoring.MOVE_QUESTION_DOWN_FULFILLED'
export const MOVE_QUESTION_DOWN_REJECTED = 'transportScoring.MOVE_QUESTION_DOWN_REJECTED'
export const MOVE_QUESTION_DOWN_CANCELLED = 'transportScoring.MOVE_QUESTION_DOWN_CANCELLED'

// Save answer

export const SAVE_ANSWER = 'transportScoring.SAVE_ANSWER'
export const SAVE_ANSWER_STARTED = 'transportScoring.SAVE_ANSWER_STARTED'
export const SAVE_ANSWER_FULFILLED = 'transportScoring.SAVE_ANSWER_FULFILLED'
export const SAVE_ANSWER_REJECTED = 'transportScoring.SAVE_ANSWER_REJECTED'
export const SAVE_ANSWER_CANCELLED = 'transportScoring.SAVE_ANSWER_CANCELLED'

// Delete answer

export const DELETE_ANSWER = 'transportScoring.DELETE_ANSWER'
export const DELETE_ANSWER_STARTED = 'transportScoring.DELETE_ANSWER_STARTED'
export const DELETE_ANSWER_FULFILLED = 'transportScoring.DELETE_ANSWER_FULFILLED'
export const DELETE_ANSWER_REJECTED = 'transportScoring.DELETE_ANSWER_REJECTED'
export const DELETE_ANSWER_CANCELLED = 'transportScoring.DELETE_ANSWER_CANCELLED'

// Move answer UP

export const MOVE_ANSWER_UP = 'transportScoring.MOVE_ANSWER_UP'
export const MOVE_ANSWER_UP_STARTED = 'transportScoring.MOVE_ANSWER_UP_STARTED'
export const MOVE_ANSWER_UP_FULFILLED = 'transportScoring.MOVE_ANSWER_UP_FULFILLED'
export const MOVE_ANSWER_UP_REJECTED = 'transportScoring.MOVE_ANSWER_UP_REJECTED'
export const MOVE_ANSWER_UP_CANCELLED = 'transportScoring.MOVE_ANSWER_UP_CANCELLED'

// Move answer DOWN

export const MOVE_ANSWER_DOWN = 'transportScoring.MOVE_ANSWER_DOWN'
export const MOVE_ANSWER_DOWN_STARTED = 'transportScoring.MOVE_ANSWER_DOWN_STARTED'
export const MOVE_ANSWER_DOWN_FULFILLED = 'transportScoring.MOVE_ANSWER_DOWN_FULFILLED'
export const MOVE_ANSWER_DOWN_REJECTED = 'transportScoring.MOVE_ANSWER_DOWN_REJECTED'
export const MOVE_ANSWER_DOWN_CANCELLED = 'transportScoring.MOVE_ANSWER_DOWN_CANCELLED'

// Save rule

export const SAVE_RULE = 'transportScoring.SAVE_RULE'
export const SAVE_RULE_STARTED = 'transportScoring.SAVE_RULE_STARTED'
export const SAVE_RULE_FULFILLED = 'transportScoring.SAVE_RULE_FULFILLED'
export const SAVE_RULE_REJECTED = 'transportScoring.SAVE_RULE_REJECTED'
export const SAVE_RULE_CANCELLED = 'transportScoring.SAVE_RULE_CANCELLED'

// Delete rule

export const DELETE_RULE = 'transportScoring.DELETE_RULE'
export const DELETE_RULE_STARTED = 'transportScoring.DELETE_RULE_STARTED'
export const DELETE_RULE_FULFILLED = 'transportScoring.DELETE_RULE_FULFILLED'
export const DELETE_RULE_REJECTED = 'transportScoring.DELETE_RULE_REJECTED'
export const DELETE_RULE_CANCELLED = 'transportScoring.DELETE_RULE_CANCELLED'
